<div class="card">
<div class="summary-title" translate>add-user.user-informations</div>
<div class="card-infos grid-6">
	<div class="card-info">
		<span class="card-info-label" translate>add-user.user-firstname</span>
		<div class="card-info-fields">
			<div class="card-info-value card-info-text-corpo-color">{{firstName}}</div>
		</div>
	</div>
	<div class="card-info">
		<span class="card-info-label" translate>add-user.user-lastname</span>
		<div class="card-info-fields">
			<div class="card-info-value card-info-text-corpo-color">{{lastName}}</div>
		</div>
	</div>
	<div class="card-info">
		<span class="card-info-label" translate>add-user.user-email</span>
		<div class="card-info-fields">

			<div class="card-info-value">{{email}}</div>
		</div>
	</div>
	<div class="card-info">
		<span class="card-info-label" translate>add-user.user-type</span>
		<div class="card-info-fields">
			<div class="card-info-value">
				<span *ngIf="userType?.toLowerCase() === 'subscription'" translate>
					quapp.notification
				</span>
				<span *ngIf="userType?.toLowerCase() === 'user'" translate>
						organizationrole.user
				</span>
			</div>
		</div>
	</div>
</div>
<div class="card-infos">
	<mat-checkbox class="obj-width" labelPosition="after" [disabled]="true" [checked]="administrator">
		<span translate>add-user.admin-user</span>
	</mat-checkbox>
</div>
<div class="matching-users" *ngIf="addedServices && addedServices.length>0">
	<div class="summary-title" translate>add-user.services</div>
	<ag-grid-angular class="ag-theme-balham grid-height" [gridOptions]="gridOptions" [modules]="modules" [rowData]="addedServices"
		(gridReady)="onGridReady($event)"></ag-grid-angular>
</div>
</div>
